/**
 * 违规评论
 */
<template>
  <div>
    
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>违规评论</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" ref="formInline" class="user-search">
      <el-form-item label="搜索：" prop="keyword">
        <el-input size="small" clearable style="width: 300px" v-model="formInline.keyword" placeholder="输入关键字"></el-input>
      </el-form-item>
      <el-form-item prop="type">
        <el-select size="small" v-model="formInline.type" placeholder="举报类型">
          <el-option v-for="type in types" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="isfinish">
        <el-select size="small" v-model="formInline.isfinish" placeholder="是否处理">
          <el-option v-for="isfinish in isfinishs" :label="isfinish.key" :value="isfinish.value" :key="isfinish.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="comment" label="违规内容" width="240">
      </el-table-column>
      <el-table-column sortable prop="description" label="所属组标题" width="240">
      </el-table-column>
      <el-table-column sortable prop="type" label="举报类型" width="120">
        <template slot-scope="{row}">
            <div style="color:blue;" v-if="row.type == 1">
                用户举报
            </div>
            <div style="color:green;" v-else-if="row.type == 0">
                系统检测
            </div>
            <div v-else>
                {{row.type}}
            </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="isfinish" label="是否已处理" width="120">
        <template slot-scope="{row}">
            <div style="color:blue;" v-if="row.isfinish == 1">
                是
            </div>
            <div style="color:red;" v-else-if="row.isfinish == 0">
                否
            </div>
            <div v-else>
                {{row.isfinish}}
            </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="nickname" label="评论人昵称" width="200">
      </el-table-column>
      <el-table-column sortable prop="reporttime" label="举报时间" width="150">
      </el-table-column>
      <el-table-column sortable prop="dealwithtime" label="处理时间" width="150">
      </el-table-column>
      <el-table-column sortable prop="handleuser" label="处理人" width="200">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="toDeal(scope.$index, scope.row)">处理</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="查看" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-form-item label="违规内容" prop="comment">
          <el-input size="small" type="textarea" :rows="4" v-model="editForm.comment" readonly auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="评论人昵称" prop="nickname">
          <el-input size="small" v-model="editForm.nickname" readonly auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属组标题" prop="description">
          <el-input size="small" type="textarea" :rows="4" v-model="editForm.description" readonly auto-complete="off" ></el-input>
        </el-form-item>
        <el-form-item label="举报类型" prop="type">
          <!-- <el-input size="small" v-model="editForm.type" readonly auto-complete="off" ></el-input> -->
          <el-select v-model="editForm.type" disabled placeholder="请选择">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.key"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否处理" prop="isfinish">
          <!-- <el-input size="small" v-model="editForm.isfinish" readonly auto-complete="off" ></el-input> -->
          <el-select v-model="editForm.isfinish" disabled placeholder="请选择">
            <el-option
              v-for="item in isfinishs"
              :key="item.value"
              :label="item.key"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="举报时间" prop="reporttime">
          <el-input size="small" v-model="editForm.reporttime" readonly auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="处理时间" prop="dealwithtime">
          <el-input size="small" v-model="editForm.dealwithtime" readonly auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="处理人" prop="handleuser">
          <el-input size="small" v-model="editForm.handleuser" readonly auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ReportList,ReportDeal } from '../../api/businessMG'
import Pagination from '../../components/Pagination'
import {dateFormat} from '../../utils/datetime'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      user: {},
      title: '添加',
      editForm: {
        id:'',
        comment: '',
        type: '',
        isfinish: '',
        reporttime: '',
        dealwithtime: '',
        handleuser: '',
        description: '',
        nickname : '',
        token: localStorage.getItem('logintoken')
      },
      types:[{key:'系统检测',value:'0'},{key:'用户举报',value:'1'}],
      isfinishs:[{key:'否',value:'0'},{key:'是',value:'1'}],
      formInline: {
        page: 1,
        limit: 10,
        keyword: '',
        type: '',
        isfinish: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.user = JSON.parse(localStorage.getItem('userdata'))
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      ReportList(parameter)
        .then(res => {
          this.loading = false
         if (res.result != 'success') {
            this.$message({
              type: 'info',
              message: '请求失败'
            })
          } else {
            this.listData = res.list
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.response.statusText)
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
 
        this.editForm.comment = row.comment
        this.editForm.type = row.type
        this.editForm.isfinish = row.isfinish
        this.editForm.reporttime = row.reporttime
        this.editForm.dealwithtime = row.dealwithtime
        this.editForm.handleuser = row.handleuser
        this.editForm.description = row.description
        this.editForm.nickname = row.nickname
      } else {
        this.editForm.comment = ''
        this.editForm.type = ''
        this.editForm.isfinish = ''
        this.editForm.reporttime = ''
        this.editForm.dealwithtime = ''
        this.editForm.handleuser = ''
        this.editForm.description = ''
        this.editForm.nickname = ''
      }
    },
    // 违规处理
    toDeal(index, row) {
      this.$confirm('确定处理?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          ReportDeal({id:row.cid,isfinish:'1',dealwithtime:dateFormat(new Date()),handleuser:this.user.username})
            .then(res => {
              if (res.result === 'success') {
                this.$message({
                  type: 'success',
                  message: '处理成功!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.result
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('处理失败，请稍后再试！')
            })
        })
        .catch((e) => {
          // console.log(e)
          this.$message({
            type: 'info',
            message: e
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    //重置
    resetForm(formName) {
        this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/miniBusiness/IllegalComment.vue